// Focus strokes are for people navigating by keyboard, and `:focus-visible` is
// not a reliable signal for that: a menu returning focus to its trigger on close
// matches it even after a mouse click. So the stroke is keyed to how the user is
// actually moving around. See `data-keyboard-nav` in public/index.html.
const root = document.documentElement;

// Arrow keys and Enter/Space are how a menu or list is driven once focus is
// inside it, so a mouse-opened menu walked with the arrows still needs strokes.
// In a text field the same keys move the caret or type, not focus, and a send
// or submit that moves focus afterwards must not flash a stroke on its target.
const NAVIGATION_KEYS = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'Enter',
  ' ',
]);

const isTextEntry = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.isContentEditable ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    (target instanceof HTMLInputElement &&
      !['checkbox', 'radio', 'button', 'submit', 'reset'].includes(
        target.type
      )));

window.addEventListener(
  'keydown',
  (event) => {
    if (
      event.key === 'Tab' ||
      (NAVIGATION_KEYS.has(event.key) && !isTextEntry(event.target))
    )
      root.dataset.keyboardNav = 'true';
  },
  true
);

window.addEventListener(
  'pointerdown',
  () => {
    delete root.dataset.keyboardNav;
  },
  true
);
